module.exports = __webpack_public_path__ + "sounds/c85d1098c32710af6169a7ea745ace44.mp3";


//////////////////
// WEBPACK FOOTER
// ./components/levels/levelPrologue/assets/sounds/success.mp3
// module id = 88
// module chunks = 0